import { ResponsiveConfig } from '../../config/responsive.config'

const setDisplayType = (state, width) => {
    let type = (width > ResponsiveConfig.mobile) ? (width > ResponsiveConfig.tablet ? "desktop" : "tablet") : "mobile";
    state.commit("SET_DISPLAY_TYPE", type)
}
const DisableContactForm = (state) => {
    state.commit("CHANGE_CONTACT_FORM_STATUS", false)
    setTimeout( () => {
        state.commit("CHANGE_CONTACT_FORM_STATUS", true)
    },300000)
}

export default {
    setDisplayType,
    DisableContactForm
}


// WEBPACK FOOTER //
// ./src/store/system/actions.js